import { Outlet } from 'react-router-dom';

import Header from "./Header.jsx"
import Footer from "./Footer.jsx"
import palette from 'utils/styles/palette.js';

export default function Body () {
  return (
    <div style={{background:palette.body,height: "100vh",minWidth: "1680px"}}>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

